import { METRICS } from './metrics';

export const cx = (...a) => a.filter(Boolean).join(' ');

export const toF = (c) => (c * 9) / 5 + 32;

// value conversion according to the user's unit preference
export const convert = (key, v, units) => {
  if (v == null || Number.isNaN(v)) return null;
  if (units === 'imperial') {
    if (key === 'temperature' || key === 'dewPoint') return toF(v);
    if (key === 'pressure') return v * 0.02953; // inHg
  }
  return v;
};
export const unitOf = (key, units) => {
  if (units === 'imperial') {
    if (key === 'temperature' || key === 'dewPoint') return '°F';
    if (key === 'pressure') return 'inHg';
  }
  return METRICS[key]?.unit || '';
};
export const fmt = (key, v, units = 'metric', withUnit = false) => {
  const c = convert(key, v, units);
  if (c == null) return '--';
  let d = METRICS[key]?.decimals ?? 1;
  if (units === 'imperial' && key === 'pressure') d = 2;
  const s = c.toLocaleString('en-US', { minimumFractionDigits: d, maximumFractionDigits: d });
  return withUnit ? `${s} ${unitOf(key, units)}` : s;
};

export const timeAgo = (d, now = Date.now()) => {
  if (!d) return 'never';
  const s = Math.max(0, Math.round((now - new Date(d).getTime()) / 1000));
  if (s < 5) return 'just now';
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.floor(s / 60)} min ago`;
  if (s < 86400) return `${Math.floor(s / 3600)} h ago`;
  return `${Math.floor(s / 86400)} d ago`;
};
export const fmtTime = (d, seconds = false) =>
  new Date(d).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', ...(seconds ? { second: '2-digit' } : {}) });
export const fmtDateTime = (d) =>
  new Date(d).toLocaleString('en-GB', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });
export const fmtDay = (d) => new Date(d).toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });
export const fmtArea = (m2) => (m2 >= 10000 ? `${(m2 / 10000).toLocaleString('en-US', { maximumFractionDigits: 1 })} ha` : `${m2} m²`);
export const greeting = () => {
  const h = new Date().getHours();
  return h < 12 ? 'Good morning' : h < 18 ? 'Good afternoon' : 'Good evening';
};
export const clamp = (v, a, b) => Math.min(b, Math.max(a, v));

// position (0..1) of a value between two limits, used by the little threshold meters
export const ratio = (v, lo, hi) => (lo == null || hi == null || hi === lo ? 0.5 : clamp((v - lo) / (hi - lo), 0, 1));

export const downloadBlob = (name, text, type = 'text/csv') => {
  const url = URL.createObjectURL(new Blob([text], { type }));
  const a = Object.assign(document.createElement('a'), { href: url, download: name });
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};
